import type { ModelName } from '@pigello/pigello-matrix';

export const TENANT_STAKEHOLDER_CHOICES = {
  TRUSTEE: 0, // godman
  CONTACT_PERSON: 1, // kontaktperson
  ADMINISTRATOR: 2, // förvaltare
  LEGAL_GUARDIAN: 3, // förmyndigare
} as const;

export const CONTRACT_STAKEHOLDER_CHOICES = {
  SUB_LEASER: 0, // andrahands HG
  GUARANTOR: 1, // borgensman
  CONSUMER: 2, // nyttjare
} as const;

export const CONTRACT_CONNECTION_STATUS = {
  INACTIVE: 0,
  UPCOMING: 1,
  FORMER: 2,
  ACTIVE: 3,
  ACTIVE_INDEFINITE: 4,
} as const;

export const SUB_TENANT_CONNECTION_TYPES = {
  TENANT: 'tenant',
  CONTRACT: 'contract',
  BRF: 'brf',
} as const;

export const SUB_TENANT_CATEGORY_CHOICES = {
  RELATIVE: 0, // Anhörig
  CLOSE_RELATIVE: 1, // Nära anhörig
  REGISTERED_PARTNERSHIP: 2, // Registrerat partnerskap
  PARTNER: 3, // Partner
  COHABITANT: 4, // Sambo
  CHILD: 5, // Barn
  WORK: 6, // Jobb
  RESIDENT: 7, // Boende
  DISABILITY_SUPPORT: 8, // Funktionsstöd
  LIVE_IN_TENANT: 9, // Inneboende
  WELFARE_SUPPORT: 10, // Stöd & försörjning
  STAFF: 11, // Medarbetare
  AUTHORIZED_SIGNATORY: 12, // Firmatecknare
  FINANCIAL_MANAGER: 13, // Ekonomiansvarig
  CONTRACT_MANAGER: 14, // Avtalsansvarig
  PREMISES_MANAGER: 15, // Lokalansvarig
  BUSINESS_UNIT: 16, // Företagsenhet
  IT_SUPPORT: 17, // IT-support
  SUPPLIER_CONTACT: 18, // Leverantörskontakt
  SECURITY_MANAGER: 19, // Säkerhetsansvarig
  LEGAL_CONTACT: 20, // Juridisk kontakt
  ICE_CONTACT: 21, // ICE-kontakt
};

export const AVAILABLE_SUB_TENANT_CONTRACT_CONNECTIONS_TYPES = {
  apartmentcontract: 'apartmentContract',
  industrialpremisescontract: 'industrialPremisesContract',
  parkingspotcontract: 'parkingSpotContract',
  outdoorsectioncontract: 'outdoorSectionContract',
} as const satisfies Partial<Record<ModelName, string>>;
